export const DOCUMENT_TYPES = 'DOCUMENT_TYPES';

export function getDocumentTypes(documentTypes) {
    return {type: DOCUMENT_TYPES, documentTypes}
}